module.exports = __webpack_public_path__ + "img/calligraphy-tiao-icon3.1767bb79.jpg";